import '../styles/singleCheckbox.less';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';

var isBorderRadiusSupportedCache;

/**
 * This function is needed only for backward compatibility for '<select>' markup (temporarily).
 */
function isValidSelectMarkup($markup) {
    var isSelect = false,
        $options = $markup.find('option');
    if ($markup.is('select')) {
        if ($options.length === 2) {
            isSelect = true;
        }
    }
    return isSelect;
}

function isBorderRadiusSupported() {
    if (isBorderRadiusSupportedCache) {
        return isBorderRadiusSupportedCache;
    }

    isBorderRadiusSupportedCache = document.createElement('div').style.borderRadius !== undefined;
    return isBorderRadiusSupportedCache;
}

/**
 * Returns true if the Single Checkbox implementation is based on sliced images.
 * Returns false if it's implemented fully in CSS.
 */
function isSliced() {
    return !isBorderRadiusSupported();
}

function getSliceSuffix() {
    return isSliced() ? '-slice' : '';
}

function getKnobOnPosition($knob) {
    var knobOnPosition = $knob.parent().width() - 22;
    if (isSliced()) {
        knobOnPosition += 8;
    }
    return knobOnPosition + 'px';
}

function getKnobOffPosition() {
    var knobOffPosition = 0;
    if (isSliced()) {
        knobOffPosition -= 14;
    }
    return knobOffPosition + 'px';
}

function animateKnobToOn($knob, enabledTypeSuffix, sliceSuffix) {
    $knob.css('left', getKnobOffPosition());
    $knob.stop().animate({'left': getKnobOnPosition($knob)}, 100, 'linear', function () {
        $knob.removeClass('uwr-single-checkbox-knob-off' + enabledTypeSuffix + sliceSuffix);
        $knob.addClass('uwr-single-checkbox-knob-on' + enabledTypeSuffix + sliceSuffix);
    });
}

function animateKnobToOff($knob, enabledTypeSuffix, sliceSuffix) {
    $knob.css('left', getKnobOnPosition($knob));
    $knob.stop().animate({'left': getKnobOffPosition()}, 100, 'linear', function () {
        $knob.removeClass('uwr-single-checkbox-knob-on' + enabledTypeSuffix + sliceSuffix);
        $knob.addClass('uwr-single-checkbox-knob-off' + enabledTypeSuffix + sliceSuffix);
    });
}

function toggleKnob($backgroundDiv, $markup, enabledTypeSuffix, sliceSuffix) {
    var $knob = $($backgroundDiv.find('.uwr-single-checkbox-knob' + enabledTypeSuffix + sliceSuffix).get(0));
    if (getMarkupState($markup)) {
        animateKnobToOn($knob, enabledTypeSuffix, sliceSuffix);
    } else {
        animateKnobToOff($knob, enabledTypeSuffix, sliceSuffix);
    }
}

function toggleLabel($backgroundDiv, $markup, sliceSuffix) {
    var $labelOn = $($backgroundDiv.find('.uwr-single-checkbox-label-on' + sliceSuffix).get(0)),
        $labelOff = $($backgroundDiv.find('.uwr-single-checkbox-label-off' + sliceSuffix).get(0));
    if (getMarkupState($markup)) {
        $labelOff.addClass('uwr-single-checkbox-hidden');
        $labelOn.removeClass('uwr-single-checkbox-hidden');
    } else {
        $labelOff.removeClass('uwr-single-checkbox-hidden');
        $labelOn.addClass('uwr-single-checkbox-hidden');
    }
}

function getMarkupType($markup) {
    var type = $markup.data('type');
    if (typeof type === 'undefined' || (type !== 'readonly' && type !== 'disabled')) {
        type = 'enabled';
    }
    return type;
}

function isEnabled($markup) {
    return getMarkupType($markup) === 'enabled';
}

function isReadonly($markup) {
    return getMarkupType($markup) === 'readonly';
}

function isDisabled($markup) {
    return getMarkupType($markup) === 'disabled';
}

function getMarkupTypeSuffix($markup) {
    var result;
    if (isEnabled($markup)) {
        result = '';
    } else {
        result = '-' + getMarkupType($markup);
    }
    return result;
}

function toggleBackgroundColor($backgroundDiv, $markup, enabledTypeSuffix, sliceSuffix) {
    var $curveLeft = $backgroundDiv.prev(),
        $curveRight = $backgroundDiv.next(),
        colorOn = $backgroundDiv.data('color-on'),
        colorOff = $backgroundDiv.data('color-off');
    if (getMarkupState($markup)) {
        $curveLeft.removeClass('uwr-single-checkbox-curve-left-' + colorOff + enabledTypeSuffix + sliceSuffix);
        $curveLeft.addClass('uwr-single-checkbox-curve-left-' + colorOn + enabledTypeSuffix + sliceSuffix);
        $backgroundDiv.removeClass('uwr-single-checkbox-background-' + colorOff + enabledTypeSuffix + sliceSuffix);
        $backgroundDiv.addClass('uwr-single-checkbox-background-' + colorOn + enabledTypeSuffix + sliceSuffix);
        $curveRight.removeClass('uwr-single-checkbox-curve-right-' + colorOff + enabledTypeSuffix + sliceSuffix);
        $curveRight.addClass('uwr-single-checkbox-curve-right-' + colorOn + enabledTypeSuffix + sliceSuffix);
    } else {
        $curveLeft.removeClass('uwr-single-checkbox-curve-left-' + colorOn + enabledTypeSuffix + sliceSuffix);
        $curveLeft.addClass('uwr-single-checkbox-curve-left-' + colorOff + enabledTypeSuffix + sliceSuffix);
        $backgroundDiv.removeClass('uwr-single-checkbox-background-' + colorOn + enabledTypeSuffix + sliceSuffix);
        $backgroundDiv.addClass('uwr-single-checkbox-background-' + colorOff + enabledTypeSuffix + sliceSuffix);
        $curveRight.removeClass('uwr-single-checkbox-curve-right-' + colorOn + enabledTypeSuffix + sliceSuffix);
        $curveRight.addClass('uwr-single-checkbox-curve-right-' + colorOff + enabledTypeSuffix + sliceSuffix);
    }
}

function toggleDiv($backgroundDiv, $markup) {
    var sliceSuffix = getSliceSuffix(),
        enabledTypeSuffix = getMarkupTypeSuffix($markup);
    toggleBackgroundColor($backgroundDiv, $markup, enabledTypeSuffix, sliceSuffix);
    toggleKnob($backgroundDiv, $markup, enabledTypeSuffix, sliceSuffix);
    toggleLabel($backgroundDiv, $markup, sliceSuffix);
}

function isChangeable($markup) {
    var readonly = isReadonly($markup),
        enabled = isEnabled($markup);
    return enabled || readonly;
}

function getVisibleState($backgroundDiv) {
    var selector = '.uwr-single-checkbox-label-off';
    if (isSliced()) {
        selector = '.uwr-single-checkbox-label-off-slice';
    }
    return $backgroundDiv.find(selector).hasClass('uwr-single-checkbox-hidden');
}

/**
 * Returns true if the Single Checkbox is on at markup level, false otherwise.
 */
function getMarkupState($markup) {
    var state = $markup.is(':checked'),
        $options = $markup.find('option');
    if (isValidSelectMarkup($markup)) {
        state = !$options.get(1).selected;
    }
    return state;
}

function setMarkupStateWithoutChange($markup, newState) {
    var $options = $markup.find('option'),
        state = getMarkupState($markup);
    if (isValidSelectMarkup($markup)) {
        state = !$options.get(1).selected;
        if (newState !== state) {
            if (newState) {
                $options.get(0).selected = true;
                $options.get(1).selected = false;
            } else {
                $options.get(0).selected = false;
                $options.get(1).selected = true;
            }
        }
    } else {
        if (newState !== state) {
            if (newState) {
                $markup[0].setAttribute('checked', '');
            } else {
                $markup[0].removeAttribute('checked');
            }
        }
    }
}

function setMarkupState($markup, newState) {
    if (isChangeable($markup) && getMarkupState($markup) !== newState) {
        setMarkupStateWithoutChange($markup, newState);
        common.dispatchEvent('change', $markup.get(0));
        $markup.focus();
    }
}

function toggleState($markup) {
    setMarkupState($markup, !getMarkupState($markup));
}

function isChanged($markup, $backgroundDiv) {
    return getMarkupState($markup) !== getVisibleState($backgroundDiv);
}

function changeHandler($markup, $backgroundDiv) {
    if (isChanged($markup, $backgroundDiv)) {
        if (isChangeable($markup)) {
            toggleDiv($backgroundDiv, $markup);
        } else if (isDisabled($markup) && isValidSelectMarkup($markup)) {
            // rollback unwanted state change on select markup
            setMarkupStateWithoutChange($markup, !getMarkupState($markup));
        }
    }
}

function keyupHandler($markup, event) {
    var $focusDiv = $markup.data('focus-div');
    if (event.which === 13) { // Enter or space on select should trigger switching
        toggleState($markup);
    }
    common.dispatchEvent('change', $markup.get(0));
    $focusDiv.focus();
}

function addListenersToMarkup($markup, $backgroundDiv) {
    common.addEventListener('change', $markup.get(0), function () {
        changeHandler($markup, $backgroundDiv);
    });
    $markup.keyup(function (event) {
        keyupHandler($markup, event);
    });
}

function isUseIconLabels($markup) {
    return typeof $markup.data('use-icon-labels') === 'undefined' || $markup.data('use-icon-labels') === true;
}

function getLabelOnText($markup) {
    var labelOnText = $markup[0].getAttribute('data-label-on'),
        $options = $markup.find('option');
    if (isValidSelectMarkup($markup)) {
        labelOnText = $options.get(0).innerHTML;
    }
    return labelOnText;
}

function getLabelOffText($markup) {
    var labelOffText = $markup[0].getAttribute('data-label-off'),
        $options = $markup.find('option');
    if (isValidSelectMarkup($markup)) {
        labelOffText = $options.get(1).innerHTML;
    }
    return labelOffText;
}

function addTypeClasses(type, $markup) {
    var sliceSuffix = getSliceSuffix(),
        $background = $markup.data('backgroundDiv'),
        colorOn = $background.data('color-on'),
        colorOff = $background.data('color-off'),
        color = (getMarkupState($markup) ? colorOn : colorOff),
        knobState = (getMarkupState($markup) ? 'on' : 'off'),
        $curveLeft = $markup.data('curveLeftDiv'),
        $curveRight = $markup.data('curveRightDiv'),
        $knob = $markup.data('knobDiv');
    $curveLeft.addClass('uwr-single-checkbox-curve-left-' + color + type + sliceSuffix);
    $background.addClass('uwr-single-checkbox-background' + type + sliceSuffix);
    $background.addClass('uwr-single-checkbox-background-' + color + type + sliceSuffix);
    $knob.addClass('uwr-single-checkbox-knob' + type + sliceSuffix);
    $knob.addClass('uwr-single-checkbox-knob-' + knobState + type + sliceSuffix);
    $curveRight.addClass('uwr-single-checkbox-curve-right-' + color + type + sliceSuffix);
}

function removeTypeClasses(type, $markup) {
    var sliceSuffix = getSliceSuffix(),
        $background = $markup.data('backgroundDiv'),
        colorOn = $background.data('color-on'),
        colorOff = $background.data('color-off'),
        color = (getMarkupState($markup) ? colorOn : colorOff),
        knobState = (getMarkupState($markup) ? 'on' : 'off'),
        $curveLeft = $markup.data('curveLeftDiv'),
        $curveRight = $markup.data('curveRightDiv'),
        $knob = $markup.data('knobDiv');
    $curveLeft.removeClass('uwr-single-checkbox-curve-left-' + color + type + sliceSuffix);
    $background.removeClass('uwr-single-checkbox-background' + type + sliceSuffix);
    $background.removeClass('uwr-single-checkbox-background-' + color + type + sliceSuffix);
    $knob.removeClass('uwr-single-checkbox-knob' + type + sliceSuffix);
    $knob.removeClass('uwr-single-checkbox-knob-' + knobState + type + sliceSuffix);
    $curveRight.removeClass('uwr-single-checkbox-curve-right-' + color + type + sliceSuffix);
}

function switchToEnabled($markup) {
    addTypeClasses('', $markup);
    removeTypeClasses('-readonly', $markup);
    removeTypeClasses('-disabled', $markup);
}

function switchToReadonly($markup) {
    addTypeClasses('-readonly', $markup);
    removeTypeClasses('', $markup);
    removeTypeClasses('-disabled', $markup);
}

function switchToDisabled($markup) {
    addTypeClasses('-disabled', $markup);
    removeTypeClasses('', $markup);
    removeTypeClasses('-readonly', $markup);
}

function setMarkupType($markup, newType) {
    if (newType === 'enabled' || newType === 'readonly' || newType === 'disabled') {
        $markup.data('type', newType);
        switch (getMarkupType($markup)) {
        case 'enabled':
            switchToEnabled($markup);
            break;
        case 'readonly':
            switchToReadonly($markup);
            break;
        case 'disabled':
            switchToDisabled($markup);
            break;
        }
        parseTypeAttribute($markup);
    }
}

function setResetHandler($markup) {
    $('form').bind('reset', function () {
        var defaultState = $markup.data('default-state');
        if (!isDisabled($markup) && defaultState !== getMarkupState($markup)) {
            setMarkupState($markup, defaultState);
        }
    });
}

function blurAll() {
    var blurFunc = function () {
            $(this).blur();
        };
    $('.uwr-single-checkbox-markup').each(blurFunc);
    $('.uwr-single-checkbox-markup-slice').each(blurFunc);
}

function addFocusDIV($markup, $backgroundDiv, $containerDiv) {
    var $focusDiv = $('<a href=\'\'></a>');
    $markup.data('focus-div', $focusDiv);
    if (isEnabled($markup)) {
        $focusDiv[0].setAttribute('tabindex', $markup[0].getAttribute('tabindex'));
        $focusDiv.appendTo($containerDiv);
        $focusDiv.addClass('uwr-single-checkbox-markup' + getSliceSuffix());
        $focusDiv.focus(function () {
            blurAll();
            if (isSliced()) {
                $containerDiv.addClass('uwr-single-checkbox-focus-slice');
            } else {
                $backgroundDiv.addClass('uwr-single-checkbox-focus');
            }
        });
        $focusDiv.focusout(function () {
            if (isSliced()) {
                $containerDiv.removeClass('uwr-single-checkbox-focus-slice');
            } else {
                $backgroundDiv.removeClass('uwr-single-checkbox-focus');
            }
        });
        $focusDiv.blur(function () {
            if (isSliced()) {
                $containerDiv.removeClass('uwr-single-checkbox-focus-slice');
            } else {
                $backgroundDiv.removeClass('uwr-single-checkbox-focus');
            }
        });
        $focusDiv.keydown(function (event) {
            if (event.which === 13 || event.which === 32) { // Enter or space on select should trigger toggle
                toggleState($markup);
                common.dispatchEvent('change', $markup.get(0));
                return false; // stop key event propagation to link
            }
        });
    }
}

function addFocusHandler($markup, $backgroundDiv, $containerDiv) {
    $markup.appendTo($containerDiv);
    $markup.addClass('uwr-single-checkbox-hidden');
    $markup.focus(function () {
        if (isEnabled($markup)) {
            blurAll();
            if (isSliced()) {
                $containerDiv.addClass('uwr-single-checkbox-focus-slice');
            } else {
                $backgroundDiv.addClass('uwr-single-checkbox-focus');
            }
        }
    });
    $markup.focusout(function () {
        if (isSliced()) {
            $containerDiv.removeClass('uwr-single-checkbox-focus-slice');
        } else {
            $backgroundDiv.removeClass('uwr-single-checkbox-focus');
        }
    });
    $markup.blur(function () {
        if (isSliced()) {
            $containerDiv.removeClass('uwr-single-checkbox-focus-slice');
        } else {
            $backgroundDiv.removeClass('uwr-single-checkbox-focus');
        }
    });
    addFocusDIV($markup, $backgroundDiv, $containerDiv);
}

function initSelectedStateInOriginalMarkup($markup) {
    if (isValidSelectMarkup($markup)) {
        var $options = $markup.find('option');
        if (!$options.get(0).selected && !$options.get(1).selected) {
            $options.get(0).selected = true;
        }
    }
}

function parseColorAttribute($markup, $backgroundDiv) {
    var colorCode = $markup.data('color'),
        colorArray;
    if (colorCode !== 'kiwi-grey' && colorCode !== 'olive-chestnut' && colorCode !== 'atlantic-chestnut') {
        colorCode = 'kiwi-grey';
    }
    colorArray = colorCode.split('-');
    $backgroundDiv.data('color-on', colorArray[0]);
    $backgroundDiv.data('color-off', colorArray[1]);
}

function parseTypeAttribute($markup) {
    if (isDisabled($markup)) {
        $markup[0].setAttribute('disabled', '');
        $markup.css('display', 'none');
    } else if (isReadonly($markup)) {
        $markup[0].removeAttribute('disabled');
        $markup.css('display', 'none');
    } else {
        $markup[0].removeAttribute('disabled');
        $markup.css('display', '');
    }
}

function buildCurveLeftDiv($markup, $backgroundDiv, colorOn, enabledTypeSuffix, sliceSuffix) {
    var $curveLeftDiv = $('<div></div>');
    $curveLeftDiv.addClass('uwr-single-checkbox-curve' + sliceSuffix);
    $curveLeftDiv.addClass('uwr-single-checkbox-curve-left-' + colorOn + enabledTypeSuffix + sliceSuffix);
    $curveLeftDiv.click(function () {
        if (isEnabled($markup)) {
            toggleState($markup);
            changeHandler($markup, $backgroundDiv);
        }
    });
    return $curveLeftDiv;
}

function buildCurveRightDiv($markup, $backgroundDiv, colorOn, enabledTypeSuffix, sliceSuffix) {
    var $curveRightDiv = $('<div></div>');
    $curveRightDiv.addClass('uwr-single-checkbox-curve' + sliceSuffix);
    $curveRightDiv.addClass('uwr-single-checkbox-curve-right-' + colorOn + enabledTypeSuffix + sliceSuffix);
    $curveRightDiv.click(function () {
        if (isEnabled($markup)) {
            toggleState($markup);
            changeHandler($markup, $backgroundDiv);
        }
    });
    return $curveRightDiv;
}

function buildLabelOnDiv(useIcon, text, sliceSuffix, colorOn) {
    var $labelOnDiv = $('<div></div>');
    $labelOnDiv.addClass('uwr-single-checkbox-label' + sliceSuffix);
    $labelOnDiv.addClass('uwr-single-checkbox-label-on' + sliceSuffix);
    if (useIcon) {
        $labelOnDiv.addClass('uwr-single-checkbox-label-on-icon-' + colorOn);
    } else {
        $labelOnDiv.html(text);
    }
    return $labelOnDiv;
}

function buildLabelOffDiv(useIcon, text, sliceSuffix, colorOff) {
    var $labelOffDiv = $('<div></div>');
    $labelOffDiv.addClass('uwr-single-checkbox-label' + sliceSuffix);
    $labelOffDiv.addClass('uwr-single-checkbox-label-off' + sliceSuffix);
    if (useIcon) {
        $labelOffDiv.addClass('uwr-single-checkbox-label-off-icon-' + colorOff);
    } else {
        $labelOffDiv.html(text);
    }
    return $labelOffDiv;
}

function buildKnobDiv(enabledTypeSuffix, sliceSuffix) {
    var $knobDiv = $('<div></div>');
    $knobDiv.addClass('uwr-single-checkbox-knob' + enabledTypeSuffix + sliceSuffix);
    $knobDiv.addClass('uwr-single-checkbox-knob-on' + enabledTypeSuffix + sliceSuffix);
    return $knobDiv;
}

function calcComponentWidth($labelOnDiv, $labelOffDiv) {
    var widthOn = $labelOnDiv.width(),
        widthOff = $labelOffDiv.width(),
        // If we use slices we have to subtract the width of the two curves
        gap = isSliced() ? 11 : 35;
    return (widthOn < widthOff ? widthOff : widthOn) + gap;
}

function configureBackgroundDiv($markup, $backgroundDiv, width, classSuffix, coloredClassSuffix) {
    $backgroundDiv.width(width);
    $backgroundDiv.addClass('uwr-single-checkbox-background' + classSuffix);
    $backgroundDiv.addClass('uwr-single-checkbox-background-' + coloredClassSuffix);
    $backgroundDiv.click(function () {
        if (isEnabled($markup)) {
            toggleState($markup);
        }
    });
}

function buildBackgroundDiv($markup) {
    var $containerDiv = $('<div></div>'),
        $backgroundDiv = $('<div></div>'),
        $labelOnDiv,
        $labelOffDiv,
        sliceSuffix = getSliceSuffix(),
        enabledTypeSuffix,
        colorOn,
        colorOff,
        width,
        classSuffix,
        coloredClassSuffix,
        $curveLeftDiv,
        $curveRightDiv,
        $knobDiv;
    $containerDiv.addClass('uwr-single-checkbox-container');
    $containerDiv.insertBefore($markup);
    initSelectedStateInOriginalMarkup($markup);
    parseColorAttribute($markup, $backgroundDiv);
    parseTypeAttribute($markup);
    enabledTypeSuffix = getMarkupTypeSuffix($markup);
    colorOn = $backgroundDiv.data('color-on');
    colorOff = $backgroundDiv.data('color-off');
    $curveLeftDiv = buildCurveLeftDiv($markup, $backgroundDiv, colorOn, enabledTypeSuffix, sliceSuffix);
    $containerDiv.append($curveLeftDiv);
    $containerDiv.append($backgroundDiv);
    $curveRightDiv = buildCurveRightDiv($markup, $backgroundDiv, colorOn, enabledTypeSuffix, sliceSuffix);
    $containerDiv.append($curveRightDiv);
    $labelOnDiv = buildLabelOnDiv(isUseIconLabels($markup), getLabelOnText($markup), sliceSuffix, colorOn);
    $backgroundDiv.append($labelOnDiv);
    $labelOffDiv = buildLabelOffDiv(isUseIconLabels($markup), getLabelOffText($markup), sliceSuffix, colorOff);
    $backgroundDiv.append($labelOffDiv);
    $knobDiv = buildKnobDiv(enabledTypeSuffix, sliceSuffix);
    $backgroundDiv.append($knobDiv);
    width = calcComponentWidth($labelOnDiv, $labelOffDiv);
    classSuffix = enabledTypeSuffix + sliceSuffix;
    coloredClassSuffix = colorOn + enabledTypeSuffix + sliceSuffix;
    configureBackgroundDiv($markup, $backgroundDiv, width, classSuffix, coloredClassSuffix);
    /* Necessary to add hidden class to $labelOffDiv only after invoking calcTextWidth
        * (called from configureBackgroundDiv()), but before setInitialCheckboxState()
        */
    $labelOffDiv.addClass('uwr-single-checkbox-hidden');
    addFocusHandler($markup, $backgroundDiv, $containerDiv);
    $markup.data('containerDiv', $containerDiv);
    $markup.data('backgroundDiv', $backgroundDiv);
    $markup.data('curveLeftDiv', $curveLeftDiv);
    $markup.data('curveRightDiv', $curveRightDiv);
    $markup.data('knobDiv', $knobDiv);
    return $backgroundDiv;
}

/**
 * SingleCheckbox is always initialized with unchecked state.
 * If the checkbox is selected or first element selected in the original select,
 * SingleCheckbox toggle will be triggered.
 */
function setInitialCheckboxState($backgroundDiv, $markup, state) {
    if (!state) {
        toggleDiv($backgroundDiv, $markup);
    }
}

function saveInitialData($markup) {
    $markup.data('default-state', getMarkupState($markup));
}

function buildComponent($markup) {
    var $backgroundDiv = buildBackgroundDiv($markup);
    saveInitialData($markup);
    setInitialCheckboxState($backgroundDiv, $markup, getMarkupState($markup));
    addListenersToMarkup($markup, $backgroundDiv);
    setResetHandler($markup);
}

function isSingleCheckbox($markup) {
    return $markup.hasClass('uwr-single-checkbox');
}

/**
 * Initializes all single checkboxes on the page. It is called by the framework once, on page load.
 * Should be called by client apps only after injecting single checkboxes dynamically.
 *
 * init() is an asynchronous call, so if some logic needs to be added once init() is finished, a callback
 * function can be passed in as a parameter.
 *
 * @param callback A Javascript function object that will be called at the end of the init() call.
 */
export function init(callback) {
    $('.uwr-single-checkbox').each(function () {
        var $sc = $(this);
        if ($sc.data('initialized') !== true) {
            buildComponent($sc);
            $sc.data('initialized', true);
        }
    });
    common.invoke(callback);
}

/**
 * Switches the given single checkbox on or off.
 *
 * @param selector CSS selector string that will return the single checkbox or checkboxes to set.
 * @param newState Boolean value specifying the new state of the single checkbox.
 */
export function setChecked(selector, newState) {
    var checked = newState === true;
    $(selector).each(function () {
        var $sc = $(this);
        if (isSingleCheckbox($sc)) {
            setMarkupState($sc, checked);
        }
    });
}

/**
 * Sets the given single checkbox's type.
 *
 * @param selector CSS selector string that will return the single checkbox or checkboxes to set.
 * @param newType String value specifying the new type of the single checkbox.
 *     Accepted values: 'enabled', 'readonly', 'disabled'
 */
export function setType(selector, newType) {
    $(selector).each(function () {
        var $sc = $(this);
        if (isSingleCheckbox($sc)) {
            setMarkupType($sc, newType);
        }
    });
}

/**
 * Toggles the single checkbox's state.
 *
 * @param selector CSS selector string that will return the single checkbox or checkboxes to toggle.
 */
export function toggle(selector) {
    $(selector).each(function () {
        var $sc = $(this);
        if (isSingleCheckbox($sc)) {
            toggleState($sc);
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./widgets/SingleCheckbox/js/singleCheckbox.js
// module id = 40
// module chunks = main